import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './engagements.intl.json';

export const useEngagementsIntl = () => useIntlModule(messages);
